import { useNavigate } from "react-router-dom";
import { XCircle, BookHeart } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center bg-white rounded-3xl border border-border p-12 max-w-md" data-testid="payment-cancel">
        <div className="flex items-center justify-center gap-2 mb-6">
          <BookHeart className="w-6 h-6 text-primary" /><span className="font-serif text-xl">Eterna</span>
        </div>
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-serif text-2xl mb-2">Pagamento annullato</h1>
        <p className="text-muted-foreground mb-6">Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.</p>
        <Button onClick={() => navigate("/piani")} className="rounded-full bg-primary hover:bg-[#c9694f] text-white" data-testid="cancel-back">Torna ai piani</Button>
      </div>
    </div>
  );
};

export default PaymentCancel;
